import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import {
    ENUMS,
    getColumnDateOption,
    getColumnSearch,
    getColumnSearchOption,
    geti18nText,
    NyDataTable,
} from '@nybble/nyreact';
import { CONSTANTS_REQ } from '../../utils/Constants';
import CompanyRegistrationEdit from './edit';
import moment from 'moment';
import { getDefaultTableParams, setToSession } from '../../utils/Utils';

const CompanyRegistrationIndex = (props: any) => {
    const setDefaultFilterValue = () => {
        return [{ field: 'confirmed', condition: 'equals_bool', value: 1 }];
    };

    return (
        <NyDataTable
            url={CONSTANTS_REQ.COMPANY_REGISTRATION.LIST}
            headerTitle={geti18nText('companyRegistration.table.header')}
            buttonsClassName={'buttons-sticky'}
            setDefaultFilterValue={setDefaultFilterValue}
            showRecordModal={true}
            modalComponent={CompanyRegistrationEdit}
            hideNewButton={true}
            scroll={{ y: 10000, x: 800 }}
            columns={[
                {
                    title: geti18nText('companyRegistration.table.column.id'),
                    dataIndex: 'id',
                    width: '10%',
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('number'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.name'),
                    dataIndex: ['name'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.vatNumber'),
                    dataIndex: ['vatNumber'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.email'),
                    dataIndex: ['email'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.firstName'),
                    dataIndex: ['firstName'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.lastName'),
                    dataIndex: ['lastName'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.address'),
                    dataIndex: ['address'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.phone'),
                    dataIndex: ['phone'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnSearch('string'),
                },
                {
                    title: geti18nText('companyRegistration.table.column.requestDate'),
                    dataIndex: ['requestDate'],
                    sorter: (a: any, b: any) => {},
                    ...getColumnDateOption(),
                    render: (text: any, record: any) => {
                        if (record.requestDate) {
                            return moment(record.requestDate).format('DD.MM.YYYY HH:mm:ss');
                        }
                    },
                },
                {
                    title: geti18nText('companyRegistration.table.column.confirmed'),
                    dataIndex: 'confirmed',
                    width: '10%',
                    render: (text: any, record: { confirmed: any }) => {
                        if (record.confirmed) {
                            return <CheckOutlined style={{ color: 'green' }} />;
                        } else {
                            return <CloseOutlined style={{ color: 'red' }} />;
                        }
                    },
                    ...getColumnSearchOption(ENUMS.ACTIVE(), 'equals_bool', setDefaultFilterValue()[0]['value']),
                    defaultFilteredValue: setDefaultFilterValue(),
                },
            ]}
            onDataLoaded={(data, params) => {
                setToSession(
                    props.tableIndex ? props.tableIndex : 'tableIndex.companyRegistrations',
                    JSON.stringify(params)
                );
            }}
            {...getDefaultTableParams(props.tableIndex ? props.tableIndex : 'tableIndex.companyRegistrations')}
        />
    );
};

export default CompanyRegistrationIndex;
